module.exports = __webpack_public_path__ + "img/skate_footer.7018c979.jpg";